module.exports = __webpack_public_path__ + "static/media/logo fashion revolution.6fa809c4.png";